import Swiper from 'swiper/swiper-bundle';

class VideoTestimonialSliderSection {
    constructor(section) {
        this.section = section;
        this.swiper = null;

        this.initSlider();
        this.bindEvents();
    }

    initSlider() {
        const swiperContainer = this.section.querySelector('.swiper-container');
        if (!swiperContainer) return;

        const pagination = this.section.querySelector('.js-video-testimonial-slider-section__pagination');

        this.swiper = new Swiper(swiperContainer, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            centeredSlides: true,
            loop: true,
            resizeObserver: true,
            speed: 500,
            pagination: pagination
                ? {
                    el: pagination,
                    clickable: true,
                }
                : false,
            breakpoints: {
                768: {
                    spaceBetween: 32,
                },
            },
            on: {
                slideChange: () => this.resetAllVideos(),
            },
        });
    }

    bindEvents() {
        // Delegated click — also covers Swiper loop clones, created after init.
        this.section.addEventListener('click', event => {
            const slide = event.target.closest('.swiper-slide');
            if (!slide) return;

            // A click on a non-active slide only centers it. We must not let the
            // click reach links or native video controls here, otherwise Swiper
            // would also fire a spurious slideChange that pauses the video.
            if (!slide.classList.contains('swiper-slide-active')) {
                event.preventDefault();
                this.centerSlide(slide);
                return;
            }

            // Active slide: the custom play button starts the video.
            const playButton = event.target.closest('.js-video-testimonial-slider-section__play');
            if (!playButton) return;

            const wrapper = playButton.closest('.js-video-testimonial-slider-section__video-wrapper');
            const video = wrapper && wrapper.querySelector('.js-video-testimonial-slider-section__video');
            if (!video) return;

            video.controls = true;
            video.play();
        });

        // The play event does not bubble, so it is captured at the section level.
        // It keeps the custom play button hidden whenever a video plays (including
        // resume via the native controls). The pause event is intentionally NOT
        // handled, so seeking/scrubbing never hides the controls or pauses playback.
        this.section.addEventListener('play', event => this.onVideoPlay(event), true);
    }

    centerSlide(slide) {
        if (!this.swiper) return;

        const loopIndex = slide.getAttribute('data-swiper-slide-index');

        if (loopIndex !== null && typeof this.swiper.slideToLoop === 'function') {
            this.swiper.slideToLoop(parseInt(loopIndex, 10));
            return;
        }

        const index = Array.prototype.indexOf.call(slide.parentElement.children, slide);
        if (index >= 0) this.swiper.slideTo(index);
    }

    onVideoPlay(event) {
        const wrapper = event.target.closest('.js-video-testimonial-slider-section__video-wrapper');
        if (!wrapper) return;

        wrapper.classList.add('is-playing');
        event.target.controls = true;
    }

    // Resets every video to its poster state. Only called on a real slide change,
    // never while interacting with the active video's controls.
    resetAllVideos() {
        // Self-hosted videos: pause and restore the poster + custom play button.
        const wrappers = this.section.querySelectorAll('.js-video-testimonial-slider-section__video-wrapper');

        wrappers.forEach(wrapper => {
            const video = wrapper.querySelector('.js-video-testimonial-slider-section__video');
            if (!video) return;

            if (!video.paused) video.pause();
            video.controls = false;
            wrapper.classList.remove('is-playing');
        });

        // YouTube players: pause every embed on slide change (requires
        // enablejsapi=1 on the embed). The newly active slide is not playing yet,
        // so pausing it is a harmless no-op. We deliberately do NOT skip the active
        // slide here: when slideChange fires, Swiper has not moved the
        // swiper-slide-active class yet, so the still-playing previous slide would
        // be skipped and only pause on the second navigation.
        const iframes = this.section.querySelectorAll('.js-video-testimonial-slider-section__iframe');

        iframes.forEach(iframe => {
            if (!iframe.contentWindow) return;

            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.js-video-testimonial-slider-section');

    if (!sections.length) return;

    sections.forEach(section => {
        new VideoTestimonialSliderSection(section);
    });
});
